import React from 'react';
import { Button } from 'components/ui';
import { wrapFunctionalComponent } from 'utils/framework';
import { IconImage } from 'ai/components/SuperChat/SuperChatHeader';

function CloseButton({ onClose, display }) {
    return (
        <Button
            css={styles.headerButton}
            display={display}
            onClick={onClose}
        >
            <IconImage src='/img/ufe/ai/super-chat/bottom-chevron.svg' />
        </Button>
    );
}

const styles = {
    headerButton: {
        minWidth: 24,
        minHeight: 24,
        height: 24,
        width: 24,
        padding: 0,
        cursor: 'pointer',
        border: 'none',
        background: 'transparent',
        alignItems: 'center',
        justifyContent: 'center'
    }
};

export default wrapFunctionalComponent(CloseButton, 'CloseButton');
